import type { EdgeType } from "./buildAccessModel";

export type EdgeLevel = "rest" | "hover" | "active";
export type EdgeVisual = { stroke: string; dash?: string };

// Unfocused edges share a muted resting color; interaction reveals the direct
// access backbone and lower-contrast effective access. The patterns distinguish
// inherited dashes from available dots without color.
export function edgeVisual(type: EdgeType, level: EdgeLevel): EdgeVisual {
  const stroke =
    level === "rest"
      ? "var(--gray-200)"
      : type === "inherited" || type === "derived"
        ? "var(--gray-600)"
        : "var(--gray-1000)";
  if (type === "inherited") return { stroke, dash: "5 4" };
  if (type === "derived") return { stroke, dash: "1 2" };
  return { stroke };
}
